import BoneMetastases from "./BoneMetastases";

export default BoneMetastases;
